import React from 'react';
import PropTypes from 'prop-types'

function SummaryListDisplay({
	title,
	label,
	labelClassName,
	list,
	listKey,
	edit,
	showEdit,
	icon,
	isMobileOnly,
	useColumns,
	emptyStateVariant,
	emptyStateTitle,
	emptyStateMessage,
	emptyActionLabel,
	showItemCount,
	showEmptyState,
	forceEmptyState
}){
	return(<>
		<div className={"px-0 float-left " + (useColumns ? "col-12" : "col-12 col-md-6")}>
			<div class="card">
				<div class="card-body">

					<div class="col-12 mt-2 pb-3 px-0 clearfix">
						<div class="col-12 pl-1 mb-2 clearfix border-bottom">
							<p class="mt-4 mb-1 fs-20 float-left">
								{title}
								{showItemCount ? <span className="badge badge-pill badge-light ml-3">{Array.isArray(list) ? list.length : 0}</span> : null}
							</p>
							{showEdit ? 
								<button className={"btn btn-xs btn-round btn-secondary fs-12 mb-3 ml-4 px-4 float-right" + (!isMobileOnly ? " mt-4" : "")} 
								onClick={edit}>
									Edit
								</button>
							: null}

						</div>

						<div className="col-12 ml-5">
							<ul className={"list-unstyled" + (useColumns ? " card-columns" : "")}>

								{list && list.length ? list.map((listItem, index) => {
									return <li className="strong" key={index}>
										{icon !== null ? <i className={icon + " strong pr-4"} aria-hidden="true"></i> : null}
										{listItem[listKey]}
									</li>
								}) : null}
								
							</ul>

							{(showEmptyState && ((Array.isArray(list) ? list.length : 0) === 0 || forceEmptyState)) ? 
								<div className={"alert position-static mt-2 mb-0 " + ((showEdit && emptyStateVariant === "warning") ? "alert-warning" : "alert-light border") } role="alert">
									<p className={"mb-1 strong " + ((showEdit && emptyStateVariant === "warning") ? "text-warning" : "text-secondary") }>
										<i className={"fa " + ((showEdit && emptyStateVariant === "warning") ? "fa-exclamation-triangle" : "fa-info-circle") + " mr-2"} aria-hidden="true"></i>
										{emptyStateTitle}
									</p>
									<p className="mb-0">{emptyStateMessage}</p>
									{showEdit ? 
										<button 
											type="button"
											className={"btn btn-xs btn-round " + ((showEdit && emptyStateVariant === "warning") ? "btn-warning" : "btn-outline-secondary") + " mt-3"}
											onClick={edit}
										>
											{emptyActionLabel}
										</button>
									: null}
								</div>
							: null}
						</div>
						{label ? <label className={labelClassName}><em>{label}</em></label> : null}
					</div>
				</div>
			</div>
		</div>

	</>)
}

SummaryListDisplay.defaultProps = {
	labelClassName: "small ml-6",
	listKey: "name",
	useColumns: false,
	icon: null,
	emptyStateVariant: "info",
	emptyStateTitle: "No entries yet",
	emptyStateMessage: "No entries have been selected yet.",
	emptyActionLabel: "Update",
	showItemCount: true,
	showEmptyState: true,
	forceEmptyState: false
}

SummaryListDisplay.propTypes = {
	title: PropTypes.string,
	label: PropTypes.string,
	labelClassName: PropTypes.string,
	list: PropTypes.array,
	listKey: PropTypes.string,
	edit: PropTypes.func,
	showEdit: PropTypes.bool,
	icon: PropTypes.string,
	isMobileOnly: PropTypes.bool,
	useColumns: PropTypes.bool,
	emptyStateVariant: PropTypes.oneOf(["info", "warning"]),
	emptyStateTitle: PropTypes.string,
	emptyStateMessage: PropTypes.string,
	emptyActionLabel: PropTypes.string,
	showItemCount: PropTypes.bool,
	showEmptyState: PropTypes.bool,
	forceEmptyState: PropTypes.bool
}

export default SummaryListDisplay;